import React from 'react';

const SkyOasisFloorplan = () => {
  return (
    <div>
      <img src="/images/floorplan-d2.jpg" alt="Floorplan D2" style={{ width: '100%' }} />
    </div>
  );
};

export default SkyOasisFloorplan;
